# Validation status filter: only shows issues with validation_status = "FAILED"
query WfaSessionIssues(
	$runId: ConditionID!
	$offset: Int
	$limit: Int
	$sort: issuesSort
	$textSearch: issuesSearchInsensitive
	$urlFilter: ConditionString
	$severityIdFilter: ConditionString
	$typeIdFilter: ConditionString
	$levelFilter: ConditionString
) {
	issues(
		run_id_eq: $runId
		offset: $offset
		limit: $limit
		sort: $sort
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id
		signature
		url
		severity_name
		type_name
		elements__component_id
		elements__selector
		elements__dom_snippet
		page_title
		run_id
		run_time
		analysis_time
		session_name
		validation_status
		summary
		description
		knowledge_base_link
		tags__id
		tags__link
		note
	}

	total: issues(
		run_id_eq: $runId
		url_eq: $urlFilter
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		conformance_eq_any_item: $levelFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
		validation_status_eq: { value: "FAILED" }
	) {
		issue_id_count
	}

	unfiltered_total: issues(run_id_eq: $runId, deleted_eq: { value: false }, validation_status_eq: { value: "FAILED" }) {
		issue_id_count
	}
}
